const translations = {
  "en": {
    "Big Tech": "Big Tech",
    "Hot": "Hot",
    "Trending": "Trending",
    "Trending Projects": "Trending Projects"
  },
  "zh-tw": {
    "Big Tech": "大科技",
    "Hot": "熱門",
    "Trending": "趨勢",
    "Trending Projects": "熱門項目"
  }
};

export default translations;
